var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [!_vm.getEvent ? _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('event.not-found')) + " ")])]) : _c('div', [_c('event-header', {
    attrs: {
      "event": _vm.getEvent
    },
    on: {
      "show-new-item-modal": _vm.onShowNewItemModal,
      "show-duplicate-modal": _vm.onShowDuplicateModal,
      "show-import-modal": _vm.onShowImportModal
    }
  }), _c('event-flow', {
    ref: "eventFlowRef",
    attrs: {
      "event": _vm.getEvent
    }
  })], 1), _c('custom-modal', {
    attrs: {
      "id": "duplicate-event-modal",
      "title": _vm.$t('dashboard.events.form.duplicate-title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('create-event-modal', {
          attrs: {
            "mode": "duplicate",
            "item": _vm.getEvent
          },
          on: {
            "success": _vm.onDuplicateSuccess,
            "close": _vm.onCloseDuplicate
          }
        })];
      },
      proxy: true
    }])
  }), _c('event-flow-import-modal', {
    attrs: {
      "downloading-template": _vm.downloadingExcelTemplate,
      "importing": _vm.importingExcel,
      "import-result": _vm.importResult
    },
    on: {
      "download-template": _vm.onDownloadTemplate,
      "import": _vm.onImport,
      "invalid-file": _vm.onInvalidFile,
      "reset": _vm.onResetImport
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }